import { render, staticRenderFns } from "./noProcessDetail.vue?vue&type=template&id=19b41bf6&scoped=true&"
import script from "./noProcessDetail.vue?vue&type=script&lang=js&"
export * from "./noProcessDetail.vue?vue&type=script&lang=js&"
import style0 from "./noProcessDetail.vue?vue&type=style&index=0&id=19b41bf6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b41bf6",
  null
  
)

export default component.exports